import React, { useState } from 'react';
import { Image } from "react-bootstrap";
import Home from "../components/pages/Home";
import CulturalPackage from '../components/pages/CulturalPackage';
import SchoolPicnic from '../components/pages/SchoolPicnic';
import SchoolPicnicSpl from '../components/pages/SchoolPicnicSpl';
import GroupPackage from '../components/pages/GroupPackage';
import PrePostWedding from '../components/pages/PrePostWedding';
import FilmShooting from '../components/pages/FilmShooting';
import ContactUs from '../components/pages/ContactUs';
import KeyInformation from "../components/pages/KeyInformation";
import Franchise from "../components/pages/Franchise";
import Packages from "../components/pages/Packages";
import HappyEnding from "../components/pages/HappyEnding";

const NavBarMbl = () => {
    const [isOpen, setIsOpen] = useState(false);

  const handleButtonClick = () => {
    setIsOpen(!isOpen);

    // Toggle a className on the body element
    document.body.classList.toggle('open');
  };

  return (
    <div>
    <div className="plus-btn-pos" onClick={handleButtonClick}>
      <div className="plus-btn">
        <div className="r1"></div>
        <div className="r2"></div>
        <div className="last"></div>
      </div>
    </div>
    <div className="menu-container">
      <div className="menu-sliders"></div>
      <div className="menu-sliders"></div>
      <div className="menu-sliders"></div>
      <div className="menu">
        <div className='logo'><a href="/"><Image src={`${process.env.PUBLIC_URL}/images/logo.png`} fluid /></a></div>
        <ul>
            <li><a href='/' className='act hover-1'>Home</a></li>
            <li><a href='/Packages' to={"/"} className='act hover-1'>Packages</a></li>
            <li><a href='/SchoolPicnic' to={"/SchoolPicnic"} className='act'>School Picnic</a></li>
            <li><a href='/SchoolPicnicSpl' to={"/SchoolPicnicSpl"} className='act'>School Picnic Spl</a></li>
            <li><a href='/GroupPackage' className='act'>Group Package</a></li>
            <li><a href='/PrePostWedding' className='act'>Pre & Post Wedding</a></li>
            <li><a href='/FilmShooting' className='act'>Film Shooting</a></li>
            <li><a href='/Franchise' className='act'>Franchise</a></li>
            <li><a href='/ContactUs' className='act'>Contact Us</a></li>  
        </ul>
      </div>
    </div>
    </div>
  )
}

export default NavBarMbl